import { httpsCallable } from 'firebase/functions';

const FAIL_OPEN_AUDIT = new Set([
  'logAuditAction',
  'logLogin',
  'logLogout',
  'logBatchedAction',
  'flushSession',
]);

const defaultLogError = ({ name, code, message, details }) => {
  console.error(`[fn:${name}]`, code, message, details);
};

import * as firebase from '@/firebase';

const defaultFirebaseLoader = () => Promise.resolve(firebase);

let firebaseLoader = defaultFirebaseLoader;

export function createApi({
  functions,
  callable = httpsCallable,
  logError = defaultLogError,
  failOpen = FAIL_OPEN_AUDIT,
} = {}) {
  if (!functions) {
    throw new Error('createApi requires a Firebase Functions instance');
  }

  const failOpenSet = new Set(failOpen);

  async function call(name, data) {
    try {
      const fn = callable(functions, name);
      const res = await fn(data ?? {});
      return res.data;
    } catch (error) {
      const code = error?.code ?? 'unknown';
      const message = error?.message;
      const details = error?.details;
      logError({ name, code, message, details, error });

      if (failOpenSet.has(name)) {
        return { success: false, skipped: true, reason: code, message };
      }

      throw error;
    }
  }

  return { call };
}

let defaultApiPromise;

async function loadDefaultApi() {
  if (!defaultApiPromise) {
    defaultApiPromise = Promise.resolve()
      .then(() => firebaseLoader())
      .then(({ functions }) => createApi({ functions }));
  }
  return defaultApiPromise;
}

export async function call(name, data) {
  const api = await loadDefaultApi();
  return api.call(name, data);
}

export async function initApiFromEnv() {
  return loadDefaultApi();
}

export function __setFirebaseLoaderForTests(loader) {
  firebaseLoader = loader;
  defaultApiPromise = undefined;
}

export function __resetFirebaseLoaderForTests() {
  firebaseLoader = defaultFirebaseLoader;
  defaultApiPromise = undefined;
}
